import { ja } from './ja';
import { en } from './en';

const translations = {
  ja: { translation: ja },
  en: { translation: en },
};

export { translations };
